var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debouncePromise } from '../utils';
import { BaseApi } from './baseApi';
import { MigrationState } from '@onereach/types-contacts-api';
const DEFAULT_MIGRATION_TIMEOUT = 900000;
export default class MigrationsApi extends BaseApi {
    migrationsStatus() {
        return this.apiCall({
            method: 'GET',
            route: 'migrations/status',
        });
    }
    getMigrationState() {
        return this.apiCall({
            method: 'GET',
            route: 'migrations/v2/status',
        });
    }
    migrationsRun() {
        return this.apiCall({
            method: 'GET',
            route: 'migrations/run',
        });
    }
    launchMigration() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiCall({
                method: 'GET',
                route: 'migrations/launch',
            });
        });
    }
    pollMigrationUntilDone(timeoutMs) {
        return __awaiter(this, void 0, void 0, function* () {
            const poll = (timeout) => __awaiter(this, void 0, void 0, function* () {
                if (timeout <= 0) {
                    return false;
                }
                const state = yield this.getMigrationState();
                if (state === MigrationState.Done) {
                    return true;
                }
                if (state === MigrationState.ToDo) {
                    this.launchMigration();
                }
                return debouncePromise(() => poll(timeout - 500), 500);
            });
            this.launchMigration();
            return debouncePromise(() => poll(timeoutMs !== undefined ? timeoutMs : DEFAULT_MIGRATION_TIMEOUT), 3000);
        });
    }
}
//# sourceMappingURL=migrationsApi.js.map